<template>
    <div class="success-revision d-flex align-items-center justify-content-center min-vh-50 p-4">
        <b-card no-body class="shadow-sm border-0 w-100 text-center" style="max-width: 600px;">
            <b-card-body class="p-5">
                <div class="mb-4 text-success">
                    <i :class="type === 'accepted' ? 'ri-award-fill' : 'ri-checkbox-circle-fill'" style="font-size: 5rem;"></i>
                </div>
                <h4 class="font-weight-bold mb-3">{{ titleText }}</h4>
                <p class="text-muted mb-4" style="font-size: 1.1rem; line-height: 1.6;">
                    {{ descriptionText }}
                </p>
                <div v-if="type === 'accepted'">
                    <b-button variant="primary" class="px-5 font-weight-bold shadow-sm" @click="goToOnlineRegistration">
                        {{ $t('go_to_payment')}} <i class="ri-arrow-right-line ml-1"></i>
                    </b-button>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "SuccessRevision",
    props: {
        type: {
            type: String,
            default: 'documents' // 'documents', 'courses' veya 'accepted'
        }
    },
    computed: {
        titleText() {
            if (this.type === 'accepted') {
                return this.$t('application_accepted_title')
            }
            if (this.type === 'courses') {
                return this.$t('course_revision_success_title')
            }
            return this.$t('documents_uploaded_successfully')
        },
        descriptionText() {
            if (this.type === 'accepted') {
                return this.$t('application_accepted_desc') ;
            }
            if (this.type === 'courses') {
                return this.$t('course_revision_success_desc');
            }
            return this.$t('missing_documents_uploaded_desc') ;
        }
    },
    methods: {
        goToOnlineRegistration() {
            this.$store.dispatch('SpecialStudentApplicationRegister/logout')
            window.location.href = '/online/registration/login';
        }
    },
    created() {
        if (this.type !== 'accepted') {
            setTimeout(() => {
                this.$store.dispatch('SpecialStudentApplicationRegister/logout')
                this.$router.push('/special-student/application/login');
            }, 5000)
        }
    }
}
</script>

<style scoped>
.min-vh-50 {
    min-height: 50vh;
}
</style>
